(function () {

  const DEFAULT_THRESHOLD = 149900; // $1499 MXN en centavos
  const BAR_ID = "fs-free-shipping-bar";

  function formatMoneyMXN(cents) {
    try {
      return (cents / 100).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN"
      });
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  async function getCart() {
    const res = await fetch("/cart.js", {
      credentials: "same-origin",
      cache: "no-store"
    });
    return await res.json();
  }

  function getHiddenCartForm() {
    return document.querySelector("div.hidden form#cart") ||
           document.querySelector("form#cart");
  }

  function buildBarLI() {
    const li = document.createElement("li");
    li.className = "mm-label";
    li.id = BAR_ID;

    li.innerHTML = `
      <a href="#" onclick="return false;">
        <div class="free-shipping-box" data-threshold="${DEFAULT_THRESHOLD}">
          <div class="free-shipping-title" data-fs-title>
            Calculando envío gratis…
          </div>
          <div class="free-shipping-bar">
            <div class="free-shipping-bar__fill"
                 data-fs-fill
                 style="width:0%"></div>
          </div>
          <div class="free-shipping-sub" data-fs-sub></div>
        </div>
      </a>
    `;

    return li;
  }

  function ensureBarInHiddenTemplate() {
    const form = getHiddenCartForm();
    if (!form) return null;

    const existing = form.querySelector(`#${BAR_ID}`);
    if (existing) return existing;

    const continueLink = form.querySelector(".mm-subclose.continue");
    if (!continueLink) return null;

    const liContinue = continueLink.closest("li");
    if (!liContinue) return null;

    const li = buildBarLI();
    liContinue.insertAdjacentElement("afterend", li);

    return li;
  }

  function updateAllBars(cart) {
    const boxes = document.querySelectorAll(".free-shipping-box[data-threshold]");
    if (!boxes.length) return;

    boxes.forEach((box) => {

      const threshold = parseInt(
        box.dataset.threshold || DEFAULT_THRESHOLD,
        10
      );

      const total =
        typeof cart.items_subtotal_price === "number"
          ? cart.items_subtotal_price
          : cart.total_price;

      const remaining = threshold - total;

      const titleEl = box.querySelector("[data-fs-title]");
      const subEl = box.querySelector("[data-fs-sub]");
      const fillEl = box.querySelector("[data-fs-fill]");

      if (!titleEl || !subEl || !fillEl) return;

      const progress = Math.max(
        0,
        Math.min(100, (total / threshold) * 100)
      );

      fillEl.style.width = progress + "%";

      if (remaining > 0) {
        titleEl.textContent =
          `Te faltan ${formatMoneyMXN(remaining)} para conseguir envío gratis 🚚`;
        subEl.textContent =
          `Meta: ${formatMoneyMXN(threshold)} · Llevas: ${formatMoneyMXN(total)}`;
      } else {
        titleEl.textContent =
          "¡Conseguiste envío gratis! 🎉";
        subEl.textContent =
          `Llevas: ${formatMoneyMXN(total)}`;
        fillEl.style.width = "100%";
      }
    });
  }

  async function refreshOnce() {
    ensureBarInHiddenTemplate();

    try {
      const cart = await getCart();
      updateAllBars(cart);
    } catch (e) {}
  }

  let pulseInterval = null;

  function pulse() {
    refreshOnce();

    clearInterval(pulseInterval);
    pulseInterval = setInterval(refreshOnce, 250);

    setTimeout(() => {
      clearInterval(pulseInterval);
    }, 1500);
  }

  // =============================
  // HOOK AJAX (clave para Add to Cart)
  // =============================
  let ajaxHooked = false;

  function hookCartAjax() {
    if (ajaxHooked) return;
    ajaxHooked = true;

    if (window.fetch) {
      const originalFetch = window.fetch;

      window.fetch = function () {
        const url = String(arguments[0] || "");
        const isCart =
          url.includes("/cart/add") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update");

        const response = originalFetch.apply(this, arguments);

        if (isCart) {
          response.then(() => {
            setTimeout(pulse, 100);
            setTimeout(pulse, 400);
            setTimeout(pulse, 900);
          }).catch(() => {});
        }

        return response;
      };
    }

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__fs_url = String(url || "");
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      const url = this.__fs_url || "";
      const isCart =
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update");

      if (isCart) {
        this.addEventListener("load", function () {
          setTimeout(pulse, 100);
          setTimeout(pulse, 400);
          setTimeout(pulse, 900);
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  function bindOnce() {
    hookCartAjax();

    document.addEventListener("click", function (e) {
      const openCart =
        e.target.closest('a[href="#cart"], .cart-button, .icon-cart');

      if (openCart) {
        setTimeout(pulse, 50);
        setTimeout(pulse, 250);
        setTimeout(pulse, 600);
      }
    });
  }

  function init() {
    bindOnce();
    setTimeout(refreshOnce, 150);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();